module.exports = __webpack_public_path__ + "static/media/amazon_clone.7993bb91.png";